const globals = {
    urlAPI: "https://gualtieriehijos.com/api",
    keyEnvialo: "b94a31c8850ae9dc2ce545db37678baf6bcf4848dfb8cd435cde90987d77a6ba13"
}
export default globals